module.exports = __webpack_public_path__ + "static/media/cart-with-items.78a21f0c.svg";